import React from 'react';

const BOLD_PATTERN = /\*\*([^*]+)\*\*/g;

export function renderBoldMarkdown(text: string): React.ReactNode {
  if (text === '') return null;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null = BOLD_PATTERN.exec(text);
  while (match !== null) {
    if (match.index > lastIndex) {
      parts.push(<span key={`t-${lastIndex}`}>{text.slice(lastIndex, match.index)}</span>);
    }
    parts.push(<strong key={`b-${match.index}`}>{match[1]}</strong>);
    lastIndex = match.index + match[0].length;
    match = BOLD_PATTERN.exec(text);
  }
  if (lastIndex < text.length) {
    parts.push(<span key={`t-${lastIndex}-end`}>{text.slice(lastIndex)}</span>);
  }
  return <>{parts}</>;
}
